import client from '../apollo';
import featureFlagQuery from '../graphql/featureFlagQuery';

// Cap the fetch so a slow/unavailable API can't leave flags unresolved for long.
// First paint is never blocked: the loader runs in the background.
const FETCH_TIMEOUT_MS = 3000;

// Fetch DB feature flags at startup and return them as a { [flagName]: checked }
// map. Invoked by the `fetchFeatureFlags` thunk in the background after first
// render; the resolved map is stored in Redux so consumers (via the
// useFeatureFlag hook) re-render once flags are available. Never throws; on
// failure it fails closed by returning an empty map (flags fall back to their
// default, false).
const loadDbFeatureFlags = async() => {
  let timeoutId;
  try {
    const request = client.query({
      query: featureFlagQuery,
      variables: { size: 100, offset: 0 },
      fetchPolicy: 'network-only',
    });

    const timeout = new Promise((_, reject) => {
      timeoutId = setTimeout(
        () => reject(new Error('feature flag fetch timed out')),
        FETCH_TIMEOUT_MS
      );
    });

    const { data } = await Promise.race([request, timeout]);
    const flags = (data && data.featureFlags) || [];

    return flags.reduce((acc, flag) => {
      acc[flag.flagName] = flag.checked;
      return acc;
    }, {});
  } catch (error) {
    // Fail closed: no flags, so consumers fall back to their default (false).
    return {};
  } finally {
    clearTimeout(timeoutId);
  }
};

export default loadDbFeatureFlags;
